import { HubCardDataOptions, useHubCardData } from './use-hub-card-data';
import {
  HubCardType,
  LowestPerformingCustomersHubCardDataContent,
} from '@/types';
import { useMemo } from 'react';

const FALLBACK_LOW_PERFORMING_CUSTOMERS_CARD_DATA_CONTENT: LowestPerformingCustomersHubCardDataContent =
  {
    items: [],
    type_subtitle: {
      en: '',
      es: '',
      fr: '',
      zh: '',
    },
  };

export const useLowestPerformingCustomersData = (
  options?: HubCardDataOptions,
) => {
  const { data, loading, error } = useHubCardData(
    HubCardType.LowestPerformingCustomers,
    {
      // use default cache policy for lowest performing customers
      fetchPolicy: options?.fetchPolicy ?? 'cache-first',
      skip: options?.skip ?? false,
    },
  );

  const gpPercentageCustomers = useMemo(
    (): LowestPerformingCustomersHubCardDataContent =>
      data?.cardData[0].card_data?.avg_gp_percentage ??
      FALLBACK_LOW_PERFORMING_CUSTOMERS_CARD_DATA_CONTENT,
    [data],
  );
  const unitsSoldCustomers = useMemo(
    (): LowestPerformingCustomersHubCardDataContent =>
      data?.cardData[0].card_data?.units_sold ??
      FALLBACK_LOW_PERFORMING_CUSTOMERS_CARD_DATA_CONTENT,
    [data],
  );

  return {
    data: data ? data.cardData[0] : undefined,
    error,
    gpPercentageCustomers,
    loading,
    unitsSoldCustomers,
  };
};
